export const red = {
  95: '#fce8e8',
  90: '#fad1d1',
  85: '#f7baba',
  80: '#f5a3a3',
  70: '#f07575',
  60: '#eb4747',
  50: '#e61919',
  40: '#b81414',
  30: '#8a0f0f',
  25: '#730d0d',
};
